export enum HandlerActions {
    CHANGE_TOTAL_PAGES = 'changeTotalPages',
    ERROR = 'error',
    CLEAR_ERRORS = 'clearErrors',
    LOADING_TRUE = 'loadingTrue',
    LOADING_FALSE = 'loadingFalse',
}

export type VisualizeEventHandler = (input: any, action: HandlerActions) => void

class VisualizeHelper {
    eventHandler: VisualizeEventHandler

    report: any

    constructor(handler: VisualizeEventHandler) {
        this.eventHandler = handler
    }

    /**
     * Type definitions do not yet exist for Visualize.js. Casting as any, for now.
     */

    private viz = (window as any).visualize

    /**
     * Get report
     * @param resourcePath
     * @param params
     * @param linkOptions
     */
    async runReport(
        resourcePath: string,
        params: any = {},
        linkOptions: any = {},
        loading?: boolean,
    ): Promise<boolean | void> {
        return new Promise((resolve, reject) => {
            this.eventHandler(loading, HandlerActions.LOADING_TRUE)
            if (this.viz) {
                this.viz((v: any) => {
                    this.report = v.report({
                        resource: resourcePath,
                        params,
                        runImmediately: false,
                        scrollToTop: false,
                        scale: 'width',
                        linkOptions,
                        loadingOverlay: true,
                        container: '#report',
                        events: {
                            reportCompleted: (status: string, error: any) => {
                                if (status === 'ready') {
                                    this.report.render().then(() => {
                                        console.debug('reportCompleted')
                                        this.eventHandler(undefined, HandlerActions.LOADING_FALSE)
                                        this.eventHandler(undefined, HandlerActions.CLEAR_ERRORS)
                                        resolve(true)
                                    })
                                }
                            },
                            pageFinal: (el: any) => {
                                console.debug('pageFinal')
                                this.eventHandler(undefined, HandlerActions.LOADING_FALSE)
                                resolve(true)
                            },
                            changeTotalPages: (total: number) => {
                                this.eventHandler(total, HandlerActions.CHANGE_TOTAL_PAGES)
                            },
                        },
                        error(e: unknown) {
                            this.eventHandler(e, HandlerActions.ERROR)
                        },
                    })

                    this.report
                        .run(() => {
                            // console.log('Running report...')
                        })
                        .fail((error: any) => {
                            this.eventHandler(error, HandlerActions.ERROR)
                            reject(error)
                        })
                        .done(() => {
                            this.eventHandler(loading, HandlerActions.LOADING_FALSE)
                            resolve(true)
                        })
                })
            }
        })
    }

    /**
     *
     * @param resourcePath
     * @param params
     */
    getAdHocView(resourcePath: string, params: any = {}) {
        return new Promise((resolve, reject) => {
            this.viz((v: any) => {
                v.adhocView({
                    container: '#report',
                    resource: resourcePath,
                    params,
                    success: (success: any) => {
                        resolve(success)
                    },
                    error: (err: any) => {
                        reject(err)
                    },
                })
            })
        })
    }

    renderNewPage = (newPage: number) => {
        this.report
            .pages(newPage)
            .run(
                undefined, // callback
                this.handleError, // errorback
            )
            .fail(this.handleError)
            .done(() => {
                this.eventHandler(undefined, HandlerActions.LOADING_FALSE)
            })
    }

    getReport(): any {
        return this.report
    }

    exportToPdf = async (setDownloadLoading: any): Promise<void> => {
        console.debug('exportToPdf')
        await this.report.run(this.jasperExportToPdf)
        setDownloadLoading(false)
    }

    jasperExportToPdf = (): void => {
        this.report
            .export({
                outputFormat: 'pdf',
            })
            .done((link: any) => {
                window.open(link.href, '_self')
            })
    }

    /**
     * Get Input control
     * @param resourcePath
     * @param params
     */
    getInputControl(resourcePath: string, params: any = {}) {
        return new Promise((resolve, reject) => {
            this.viz((v: any) => {
                v.inputControls({
                    resource: resourcePath,
                    params,
                    success: (success: any) => {
                        resolve(success)
                    },
                    error: (err: any) => {
                        // console.log('getReport', err);
                        reject(err)
                    },
                })
            })
        })
    }

    handleError(error: any) {
        this.eventHandler(error, HandlerActions.ERROR)
    }

    /**
     * Get list of reports in repo folder
     * @param folderUrl
     * @param reportTypes
     */
    getReportList(folderUrl: string, reportTypes: any) {
        return new Promise((resolve, reject) => {
            this.viz((v: any) => {
                v.resourcesSearch({
                    folderUri: folderUrl,
                    recursive: true,
                    // types: [reportTypes],
                    success(repo: any) {
                        resolve(repo)
                    },
                    error(err: any) {
                        reject(err)
                    },
                })
            })
        })
    }
}
export default VisualizeHelper
